import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

export const ConsolidateDialog = ({ isOpen, existingPlant, onConsolidate, onCreateNew, onCancel }) => {
  const { t } = useLanguage();

  if (!isOpen || !existingPlant) return null;

  const photoCount = existingPlant.photo_drive_ids?.length || (existingPlant.photo_drive_id ? 1 : existingPlant.has_photo ? 1 : 0);
  const remaining = 5 - photoCount;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="consolidate-dialog-title"
      onKeyDown={(e) => { if (e.key === 'Escape') onCancel(); }}
      data-testid="consolidate-dialog"
    >
      <div className="bg-white rounded-xl shadow-2xl max-w-md mx-4 overflow-hidden">
        <div className="px-6 pt-6 pb-4">
          <h3 id="consolidate-dialog-title" className="text-lg font-semibold" style={{ color: 'hsl(143, 28%, 25%)' }} data-testid="consolidate-title">
            {t('duplicateFound') || 'Duplicate Found'}
          </h3>
          <p className="mt-2 text-sm text-gray-600">
            A plant named <strong>"{existingPlant.common_name}"</strong> already exists
            {photoCount > 1 && ` with ${photoCount} photos`}.
          </p>
          {remaining > 0 ? (
            <p className="mt-1 text-sm text-gray-500">
              You can add this photo to the existing record ({remaining} photo slot{remaining > 1 ? 's' : ''} remaining).
            </p>
          ) : (
            <p className="mt-1 text-sm text-amber-600">
              This plant already has the maximum of 5 photos.
            </p>
          )}
        </div>
        <div className="px-6 pb-6 space-y-2">
          {remaining > 0 && (
            <button
              onClick={onConsolidate}
              className="w-full py-2.5 px-4 rounded-lg text-sm font-medium text-white transition-colors"
              style={{ backgroundColor: 'hsl(143, 28%, 35%)' }}
              data-testid="consolidate-add-photo-btn"
            >
              Add photo to existing record
            </button>
          )}
          <button
            onClick={onCreateNew}
            className="w-full py-2.5 px-4 rounded-lg text-sm font-medium border transition-colors hover:bg-gray-50"
            style={{ borderColor: 'hsl(143, 28%, 35%)', color: 'hsl(143, 28%, 35%)' }}
            data-testid="consolidate-create-new-btn"
          >
            Create as separate entry
          </button>
          <button
            onClick={onCancel}
            className="w-full py-2.5 px-4 rounded-lg text-sm font-medium text-gray-500 hover:bg-gray-100 transition-colors"
            data-testid="consolidate-cancel-btn"
          >
            {t('cancel') || 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};
